// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__h9SP_","inputWrap":"styles_inputWrap__XCQuN","input":"styles_input__3v77a"};